<template>
    <div class="w-full py-2 rounded-xl border-blue-dark border-2 flex flex-col sm:flex-row justify-around items-center">
        <div class="w-full py-2">
            <p><b class="text-blue-dark">Código queja</b></p>
            <p v-if="code"><b>{{code}}</b></p>             
        </div>
        <span class="block w-3/4 h-px sm:w-1 sm:h-16 bg-blue-dark"></span>
        <div class="w-full py-2">
            <p><b class="text-blue-dark">Estado</b></p>             
            <ComplaintEmisorStatusLabel :status="status" />
        </div>
    </div>
</template>

<script>

import ComplaintEmisorStatusLabel from "@/feature/dashboard/complaints_emisor/presentation/partials/ComplaintEmisorStatusLabel.vue";
export default {
    props: ['code', 'status'],
    components: {
        ComplaintEmisorStatusLabel
    }
}
</script>